const vars = {
	breakpoint: {
		mobile: 425,
		tablet: 768,
		laptop: 992,
		desktop: 1280,
		largest: 1366,
	},
};

export { vars };
